import {  DatePipe } from '@angular/common';
import { APP_INITIALIZER, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppComponent } from "@app/app.component";
import { AppRoutingModule, routeGuards, routePages } from "@app/app.routing.module";
import { AvatarImageComponent, SymptomsViewComponent } from "@shared/components";
import { AppConfig, AppData } from "@shared/services";
import { SharedModule } from "@shared/shared.module";
import { LayoutComponent } from './areas/layout/layout.component';
import { QRCodeModule } from 'angularx-qrcode';
import { CountdownModule } from 'ngx-countdown';
import { environment } from '@src/environments';
//import { ImageDrawingModule } from 'ngx-image-drawing';

import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { getDatabase, provideDatabase } from '@angular/fire/database';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

const components = [AvatarImageComponent, SymptomsViewComponent];

@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        SharedModule.forRoot(),
        AppRoutingModule,
        QRCodeModule,
       // ImageDrawingModule,
        CountdownModule,
        NgxExtendedPdfViewerModule,
        PdfViewerModule,
        provideFirebaseApp(() => initializeApp(environment.firebase)),
        provideDatabase(() => getDatabase()),
    ],
    declarations: [
        AppComponent,
        LayoutComponent,
        components,
        routePages

    ],
    providers: [
        AppData,
        AppConfig,
        routeGuards,
        DatePipe,
        {
            provide: APP_INITIALIZER,
            useFactory: (config: AppConfig) => () => config.load(),
            deps: [AppConfig],
            multi: true
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}